import useSWR from 'swr';
import axios from 'axios';
import { getApiBaseUrl } from '../langganan/langgananUtil';

// Apakah cabang punya akun Midtrans yang berlaku (pusat atau milik cabang). Selama belum diketahui
// (memuat / gagal) dianggap ada, supaya gangguan jaringan sesaat tidak menyembunyikan QRIS;
// backend tetap menolak transaksi QRIS bila akun belum ada. Dicek ulang tiap menit dan saat tab kembali
// dibuka, karena superadmin / admin cabang bisa mengubah integrasi kapan saja.
export const useMidtransCabang = (cabangUuid) => {
  const { data } = useSWR(
    cabangUuid ? `/integrasi-publik/midtrans/${cabangUuid}` : null,
    (key) => axios.get(`${getApiBaseUrl()}${key}`).then((res) => res.data.data),
    { refreshInterval: 60000, revalidateOnFocus: true }
  );
  return data ? !!data.tersedia : true;
};

export default useMidtransCabang;
